module.exports = __webpack_public_path__ + "img/img86.4d476143.png";